import { Flex, Text } from '@chakra-ui/react';
import { formatPercentage } from '../functions';

interface GrossMarginSummaryValueProps {
    grossMargin?: number | null;
    minThreshold?: number | null;
    size?: 'sm' | 'lg';
    align?: 'left' | 'right';
    decimalPoints?: number;
}

export const formatMinGrossMarginThresholdSubtext = (minThreshold?: number | null): string | undefined => {
    if (minThreshold == null) return undefined;
    return `Min ${formatPercentage(minThreshold)}`;
};

const GrossMarginSummaryValue = ({
    grossMargin,
    minThreshold,
    size = 'lg',
    align = 'left',
    decimalPoints = 1,
}: GrossMarginSummaryValueProps) => {
    const valueFontSize = size === 'sm' ? 'md' : 'lg';
    const subtext = formatMinGrossMarginThresholdSubtext(minThreshold);
    const isBelowThreshold = minThreshold != null && grossMargin != null && grossMargin < minThreshold;

    return (
        <Flex direction="column" align={align === 'right' ? 'flex-end' : 'flex-start'}>
            <Text
                fontSize={valueFontSize}
                fontWeight="bold"
                color={isBelowThreshold ? 'red.500' : 'gray.900'}
                whiteSpace="nowrap"
            >
                {grossMargin != null ? formatPercentage(grossMargin, decimalPoints) : '—'}
            </Text>
            {subtext && (
                <Text fontSize="xs" color="gray.500" whiteSpace="nowrap">
                    {subtext}
                </Text>
            )}
        </Flex>
    );
};

export default GrossMarginSummaryValue;
